import React from 'react';

const CopyWrite = () => {
  return (
    <section className="bg-[#0D1B2A] text-[#F1F5F9] py-4">
      <div className="container mx-auto text-center">
        <h2 className="text-lg md:text-xl font-semibold animate__animated animate__fadeIn animate__delay-1s">
          © 2025 Ali Hassan. All rights reserved.
        </h2>
      </div>
    </section>
  );
};

export default CopyWrite;
